import React, { useEffect, useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { CameraAltOutlined } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { uploadDocumentFile } from '../../../services/documents';
import { app } from '../../../services';

const FileInput = ({ defaultValue, id, files = [], label = 'Archivos' }) => {
  const [selectedFile, setSelectedFile] = useState(
    !!defaultValue ? { id: defaultValue, uri: null } : null
  );
  const [uploading, setUploading] = useState(false);
  const token = useSelector((state) => state.session.token);
  const institution = useSelector((state) => state.session.institution);
  const user = useSelector((state) => state.session.globalUser);

  const resolvePreviewUri = async (documentId) => {
    if (!documentId) return null;
    try {
      const doc = await app.service('documents').get(documentId, {
        query: { id_institucion: institution?.id }
      });
      return doc?.vc_url || null;
    } catch (error) {
      return null;
    }
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const file = files[0] || null;

    if (!!file) {
      setSelectedFile(null);
      handleUpload(file);
    }
    event.target.value = '';
  };

  const handleUpload = async (file) => {
    if (!!file) {
      try {
        if (!token) throw new Error('Sesión no autenticada.');
        if (!institution?.id) throw new Error('Institución no seleccionada.');
        setUploading(true);
        const uploaded = await uploadDocumentFile({
          file,
          id_institucion: institution.id,
          id_owner: user?.id || undefined,
          id_cliente: null,
          vc_nombre_original: file.name
        });
        setSelectedFile({
          id: uploaded?.id || null,
          uri: uploaded?.vc_url || null
        });
      } catch (error) {
        console.error('Error al subir el archivo:', error);
      } finally {
        setUploading(false);
      }
    }
  };

  useEffect(() => {
    let cancelled = false;
    if (!!defaultValue && !selectedFile?.uri) {
      resolvePreviewUri(defaultValue).then((uri) => {
        if (cancelled) return;
        setSelectedFile({ id: defaultValue, uri });
      });
    }
    return () => {
      cancelled = true;
    };
  }, [defaultValue, institution?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ width: '100%', position: 'relative', overflow: 'hidden' }}>
      <Box style={{ width: '100%', position: 'relative', padding: 4, maxHeight: 200 }}>
        <Stack direction="row" justifyContent={'center'} spacing={2}>
          <div style={{ flex: '0 0 auto', padding: 10, paddingRight: 10 }}>
            {
              !selectedFile?.uri ?
                <Button variant='text' fullWidth disabled={uploading}>
                  <CameraAltOutlined style={{ height: 100, fontSize: 100, color: 'gray' }} />
                </Button> :
                <Button variant='text' disabled={uploading}>
                  <img sizes='100px' alt="I" src={selectedFile?.uri} style={{ height: 100, borderRadius: 5, boxShadow: '0px 0px 10px rgba(50,50,50,0.8)' }} />
                </Button>
            }
            <input id={id} hidden onChange={() => console.log('cambio')} value={selectedFile?.id || ''} />
            <input type="file" accept="image/*" onChange={handleFileChange} style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%', opacity: 0, zIndex: 5000 }} />
          </div>
        </Stack>
      </Box >
      <div style={{ position: 'relative', overflow: 'hidden', flexDirection: 'row', display: 'flex' }}>
        <Typography style={{ flex: 1, width: '100%', textAlign: 'center' }}>
          {uploading ? 'Subiendo imagen...' : label}
        </Typography>
      </div>
    </div >
  );
};

export default FileInput;
